import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { hrs } from "@/lib/clipboard";

const fmt = (iso) => (iso ? new Date(iso).toUTCString().slice(5, 17) : "");

export default function Embed() {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.widgetLatest().then(setD).catch(() => {});
    load();
    const t = setInterval(load, 300000);
    return () => clearInterval(t);
  }, []);
  const lt = d?.latest;
  return (
    <a href={lt?.link || d?.page || "/confirmed"} target="_blank" rel="noopener noreferrer" data-testid="embed-widget"
      className="block w-[440px] max-w-full h-[190px] bg-[#05070A] border border-white/10 border-l-4 border-l-[#00F0FF] p-4 font-mono text-white overflow-hidden hover:border-white/25 transition-colors">
      <div className="flex items-center justify-between">
        <span className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-emerald-400">
          <img src="/vigilo-mark-dark.png" alt="" className="w-5 h-5" /> Vigilo Earth · Latest confirmed
        </span>
        <span className="text-[9px] text-atlas-secondary">{fmt(lt?.confirmed_at)}</span>
      </div>
      {lt ? (
        <div className="flex items-end justify-between gap-3 mt-4">
          <div className="min-w-0">
            <div className="text-[15px] truncate" data-testid="embed-place">{lt.hazard_label} · {lt.place}</div>
            <div className="text-[10px] text-atlas-secondary truncate mt-1">{lt.title}</div>
          </div>
          <div className="text-right shrink-0">
            <div className="text-3xl text-[#00F0FF]" data-testid="embed-lead">+{hrs(lt.lead_hours)}</div>
            <div className="text-[9px] uppercase tracking-wider text-atlas-secondary">before {lt.source}</div>
          </div>
        </div>
      ) : (
        <div className="text-[13px] text-atlas-secondary mt-6" data-testid="embed-empty">Awaiting the first confirmed call.</div>
      )}
      <div className="flex justify-between border-t border-white/10 mt-4 pt-2 text-[9px] uppercase tracking-widest text-atlas-secondary">
        <span data-testid="embed-median">Median lead {hrs(d?.median_lead_h)}</span>
        <span>{d?.confirmed ?? 0} confirmed</span>
      </div>
    </a>
  );
}
